var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-checkbox',{attrs:{"indeterminate":_vm.value === 0,"value":_vm.value,"true-label":1,"false-label":2},on:{"input":_vm.handleTriStateChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }